import { getByUuid } from "@/Services/TherapyApi/LegalAgreements";

async function getLegalAgreementAH(uuid: string, contract_uuid: string) {
  return getByUuid(uuid, contract_uuid);
}

export default getLegalAgreementAH;
